import { Authenticator } from '@aws-amplify/ui-react';
import React from 'react';
import ReactDOM from 'react-dom';

import App from '@src/routes/provider';

import * as serviceWorker from './serviceWorker';
require('dotenv').config();

ReactDOM.render(
  <Authenticator.Provider>
    <App />
  </Authenticator.Provider>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept('@src/routes/provider', () => {
    const NextApp = require('@src/routes/provider').default;
    ReactDOM.render(<NextApp />, document.getElementById('root'));
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
